/** Perfil de cliente solo en frontend. Clave por negocio: `customer_<businessId>`. */

import { normalizeCustomerPhone } from '@/lib/phone';

const LEGACY_STORAGE_KEY = 'customer';

function storageKey(businessId) {
  return `customer_${String(businessId ?? '')}`;
}

function normalize(data) {
  return {
    name: String(data.name ?? '').trim(),
    phone: normalizeCustomerPhone(data.phone ?? ''),
    email: String(data.email ?? '').trim(),
    address: String(data.address ?? '').trim(),
    sessionToken: String(data.sessionToken ?? '').trim(),
  };
}

/** Copia `customer` global a este negocio si aún no hay clave (una vez). */
function tryMigrateLegacy(businessId) {
  if (!businessId) return null;
  try {
    const raw = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    const payload = normalize(data);
    localStorage.setItem(storageKey(businessId), JSON.stringify(payload));
    localStorage.removeItem(LEGACY_STORAGE_KEY);
    return payload;
  } catch {
    return null;
  }
}

export function readLocalCustomer(businessId) {
  if (!businessId) return null;
  try {
    const raw = localStorage.getItem(storageKey(businessId));
    if (raw) {
      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;
      return normalize(data);
    }
    return tryMigrateLegacy(businessId);
  } catch {
    return null;
  }
}

export function isLocalCustomerComplete(c) {
  return !!(c && c.name && c.phone);
}

export function saveLocalCustomer(data, businessId) {
  const bid = String(businessId ?? '');
  if (!bid) return null;
  let base = null;
  try {
    const raw = localStorage.getItem(storageKey(bid));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') base = normalize(parsed);
    }
  } catch {
    // ignore
  }
  const payload = normalize({ ...(base || {}), ...data });
  localStorage.setItem(storageKey(bid), JSON.stringify(payload));
  try {
    localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // ignore
  }
  return payload;
}

export function clearLocalCustomer(businessId) {
  if (!businessId) return;
  localStorage.removeItem(storageKey(businessId));
}

export function getCustomerSessionToken(businessId) {
  return readLocalCustomer(businessId)?.sessionToken || '';
}

export function saveCustomerSessionToken(businessId, token) {
  const bid = String(businessId ?? '');
  const t = String(token ?? '').trim();
  if (!bid || !t) return;
  saveLocalCustomer({ sessionToken: t }, bid);
}

export function clearCustomerSessionToken(businessId) {
  const bid = String(businessId ?? '');
  if (!bid) return;
  saveLocalCustomer({ sessionToken: '' }, bid);
}

export function saveCustomerSessionFromApi(businessId, data) {
  const token = data?.session_token;
  if (token) saveCustomerSessionToken(businessId, token);
}
